<template>
  <div class="avatar-editor">
    <div v-if="visiblePreview && avatarIsSet" class="avatar-editor__image">
      <img :src="vueAvatar.dataImageUrl" />
      <i class="avatar-editor__delete el-icon-delete"
        @click="deleteAvatar"></i>
    </div>

    <div v-if="!avatarIsSet">
      <vue-avatar
        :width="600"
        :height="600"
        :scale="vueAvatar.scale"
        :rotation="vueAvatar.rotation"
        :borderRadius="600"
        @removeImage="removeImage"
        ref="vueavatar"
        @vue-avatar-editor:image-ready="showControls = true">
      </vue-avatar>

      <template v-if="showControls">
        <div class="avatar-editor__control">
          <i class="avatar-editor__rotate el-icon-refresh"
            @click="rotateAvatar"></i>
          <el-slider class="avatar-editor__slider"
                    v-model="vueAvatar.scale"
                    :min="1"
                    :max="3"
                    :step="0.01">
          </el-slider>
        </div>
        <el-button @click="saveClicked">{{ $t('labels.save') }}</el-button>
      </template>
    </div>
  </div>
</template>

<script>
  import VueAvatar from './VueAvatar';
  import data2blob from 'vue-image-crop-upload/utils/data2blob.js';
  import mimes from 'vue-image-crop-upload/utils/mimes.js';

  export default {
    props: {
      visiblePreview: {
        type: Boolean,
        default: true
      }
    },
    components: {
      VueAvatar
    },
    data () {
      return {
        vueAvatar: {
          rotation: 0,
          scale: 1,
          dataImageUrl: null
        },
        showControls: false
      }
    },
    computed: {
      avatarIsSet () {
        return !!this.vueAvatar.dataImageUrl;
      }
    },
    methods: {
      removeImage() {
        this.$emit('removeImage')
      },
      deleteAvatar (index) {
        this.reset()
        this.$emit('deleted');
      },
      reset () {
        this.showControls = false;
        this.vueAvatar = {
          rotation: 0,
          scale: 1,
          dataImageUrl: null
        }
      },
      saveClicked () {
        let dataImage = this.$refs.vueavatar.getImageScaled().toDataURL();
        this.vueAvatar.dataImageUrl = dataImage;
        let blob = data2blob(dataImage, mimes.jpg);
        this.$emit('saved', dataImage, blob)
      },
      rotateAvatar () {
        this.vueAvatar.rotation += 90;
      }
    }
  }
</script>

<style lang="scss">
$screen-sm:           768px;
$screen-md:           992px;
$screen-lg:           1200px;
$max-container-width: $screen-lg;

.avatar-editor {
  width: 300px;

  @media only screen and (max-width: $screen-sm) {
    width: 250px;
    max-width: 100%;
  }

  &__control {
    display: grid;
    grid-template-columns: 45px  1fr;
    align-items: center;
    margin-bottom: 10px;
  }

  &__rotate {
    font-size: 24px;
    cursor: pointer;
  }

  &__image {
    width: 300px;

    @media only screen and (max-width: $screen-sm) {
      width: 250px;
    }
    img {
      width: 100%;
      margin-bottom: 10px;
      border-radius: 6px;

      @media only screen and (max-width: $screen-sm) {
        width: 250px;
        height: 250px;
      }
    }
  }
  &__delete {
    font-size: 24px;
    cursor: pointer;
  }
}

</style>